import { render, staticRenderFns } from "./WeekToggle.vue?vue&type=template&id=196a936c&scoped=true&lang=pug&"
import script from "./WeekToggle.vue?vue&type=script&lang=coffee&"
export * from "./WeekToggle.vue?vue&type=script&lang=coffee&"
import style0 from "./WeekToggle.vue?vue&type=style&index=0&id=196a936c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a936c",
  null
  
)

export default component.exports